<template>
  <svg width="2em" height="2em" viewBox="0 0 15 15" fill="none" xmlns="http://www.w3.org/2000/svg">
    <path d="M8.12361 9.52355L5.83028 11.5635L6.18228 13.1789L4.52361 14.8375L2.85228 12.2235L0.238281 10.5522L1.89695 8.89355L3.60028 9.33355L5.55161 6.95155L1.43761 4.20888L3.32295 2.32288L8.46695 4.03821L10.9956 1.50955C11.7763 0.728213 12.9856 0.670879 13.6956 1.38088C14.4056 2.09088 14.3476 3.29955 13.5669 4.08088L11.0383 6.60955L12.7523 11.7515L10.8669 13.6375L8.12428 9.52355H8.12361Z" fill="currentColor"/>
  </svg>
</template>
